import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, observable, throwError, of, Subscription } from 'rxjs';
import {
  CURRENT_ENVIROMENT, SERVICE_END_POINT,
  CurrencyFunctionalityService, FundsFunctionalityService
} from '../../../shared';
@Injectable({
  providedIn: 'root'
})
export class AnnuityReadyService {
  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];
  constructor(private http: HttpClient) { }
  annuityReadyRequest(refNumber): Observable<any> {
    if (CURRENT_ENVIROMENT.environment === 'localEnvironment') {
      return this.http.get<any>(this.endPoints.getWOMDetails).map((res: Response) => {
        return res;
      }); 
    } else {
      // return this.http.get<any>(this.endPoints.getWOMDetails + refNumber.toString()).
      //   map((res: Response) => {
      //     return res;
      //   });
      return this.http.post(this.endPoints.getWOMDetails, refNumber.toString());
    }
  }

}
